export default __webpack_public_path__ + "img/fc6ab474ec803bcb3c98f89f1661a520.png";